import React from "react";
import RegistrationForm from "./RegistrationForm";
import RegisterCourse from "./RegisterCourse";
import Footer from "../../../Components/Footer/Footer";
import { frontend_data } from "../ServicesDisplayPage/servicesData";

const Register_frontend = () => {
  const page_data = {
    data: frontend_data,
    title: "Frontend Development",
    description: "Learn Frontend Development with React, HTML, CSS & JS",
    amount: 3500, // 👈 you can set course fee here
  };

  return (
    <>
      {/* Registration Form instead of Hero */}
      <RegistrationForm page_data={page_data} />

      {/* Service Body (course details/steps) */}
      <RegisterCourse service_steps={page_data} />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Register_frontend;
